import React from 'react'

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'

export const HowItWorks = () => {

    return (
        <>
            <Header />
            <div id="sign-in-dialog" className="zoom-anim-dialog">
                <div>
                    <h2>¿Cómo funciona?</h2>
                    <h4>Espere un momento por favor ....</h4>
                </div>
                <br />
            </div>
            <Footer />
        </>
    )
}